import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import './file-uploader.scss';
// import FileType from '../file-type/file-type';
import FileItem from '../file-item/file-item';
import { CloudUploadIcon } from '../icons/icons';
import Action from '../action/action';

const FileUploader = forwardRef(
  (
    {
      label,
      errorMessage,
      message,
      required,
      className,
      onClick,
      uploadedAttachement,
      removeDocument,
      disabledRemove,
      t,
      isdisableduploadbutton,
    },
    ref
  ) => {
    return (
      <div className={`file-uploader ${className}`}>
        {label && (
          <p className="label">
            {label}
            {required && <span className="required">*</span>}
          </p>
        )}
        <div className="file-uploader-container d-flex">
          {uploadedAttachement?.length > 0 &&
            uploadedAttachement
              ?.slice(0, 2)
              ?.map((item) => (
                <FileItem
                  className="m-0 mr-10"
                  file={item?.mimeType}
                  fileName={item?.originalName}
                  onDiscard={removeDocument}
                  docId={item?.docId}
                  disabledRemove={disabledRemove}
                />
              ))}
          {uploadedAttachement?.length > 2 && (
            <Action
              className="icon-button s-default justify-center primary"
              label={`+${(uploadedAttachement?.length ?? 0) - 2}`}
            >
              {uploadedAttachement?.length > 0 &&
                uploadedAttachement
                  ?.slice(2)
                  ?.map((item) => (
                    <FileItem
                      file={item?.mimeType}
                      fileName={item?.originalName}
                      onDiscard={removeDocument}
                      docId={item?.docId}
                      disabledRemove={disabledRemove}
                      className="border-none m-0 w-100"
                      formatLimit={30}
                    />
                  ))}
            </Action>
          )}
          {!disabledRemove && (
            <button
              type="button"
              disabled={isdisableduploadbutton}
              className="browse"
              onClick={onClick}
              ref={ref}
            >
              <CloudUploadIcon />
              {t(
                'managebookingscreen.bookingdetails.sendquotationbtn.sendquotationtab.upload'
              )}
            </button>
          )}
        </div>
        {message !== '' && <p className="message">{message}</p>}
        {errorMessage !== '' && <p className="error-message">{errorMessage}</p>}
      </div>
    );
  }
);

export default FileUploader;
FileUploader.propTypes = {
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  message: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  uploadedAttachement: PropTypes.instanceOf(Array),
  removeDocument: PropTypes.func,
  t: PropTypes.func,
  disabledRemove: PropTypes.bool,
  isdisableduploadbutton: PropTypes.bool,
};
FileUploader.defaultProps = {
  label: '',
  errorMessage: '',
  required: false,
  message: '',
  className: '',
  onClick: () => {},
  uploadedAttachement: [],
  removeDocument: () => {},
  t: () => {},
  disabledRemove: false,
  isdisableduploadbutton: false,
};
